/**
 * Indian-style currency & number formatting utilities.
 * Standardized across all dashboards.
 *
 * Rules:
 *   - >= 1 Cr (10,000,000)  → "₹X.XX Cr"
 *   - >= 1 Lakh (100,000)   → "₹X.XX L"
 *   - >= 1 Thousand (1,000) → "₹X.XX K"
 *   - else                  → "₹X.XX"
 *   - null/undefined/NaN    → "N/A"
 *
 * Always 2 decimals.
 */

export const fmtINR = (v, opts = {}) => {
  const { showSymbol = true, fallback = 'N/A' } = opts;
  if (v === null || v === undefined || Number.isNaN(Number(v))) return fallback;
  const n = Number(v);
  const s = showSymbol ? '₹' : '';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1e7) return `${sign}${s}${(abs / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `${sign}${s}${(abs / 1e5).toFixed(2)} L`;
  if (abs >= 1e3) return `${sign}${s}${(abs / 1e3).toFixed(2)} K`;
  return `${sign}${s}${abs.toFixed(2)}`;
};

export const fmtNumber = (v, opts = {}) => {
  const { fallback = 'N/A', decimals = 0 } = opts;
  if (v === null || v === undefined || Number.isNaN(Number(v))) return fallback;
  const n = Number(v);
  if (decimals > 0) return n.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return n.toLocaleString('en-IN');
};

export const fmtCount = (v, opts = {}) => {
  const { fallback = 'N/A' } = opts;
  if (v === null || v === undefined || Number.isNaN(Number(v))) return fallback;
  const n = Number(v);
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1e7) return `${sign}${(abs / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `${sign}${(abs / 1e5).toFixed(2)} L`;
  if (abs >= 1e3) return `${sign}${(abs / 1e3).toFixed(2)} K`;
  return `${sign}${abs}`;
};

export const fmtPct = (v, opts = {}) => {
  const { fallback = 'N/A', decimals = 2 } = opts;
  if (v === null || v === undefined || Number.isNaN(Number(v))) return fallback;
  return `${Number(v).toFixed(decimals)}%`;
};

export const fmtDecimal = (v, opts = {}) => {
  const { fallback = 'N/A', decimals = 2 } = opts;
  if (v === null || v === undefined || Number.isNaN(Number(v))) return fallback;
  return Number(v).toFixed(decimals);
};

export const isNA = (v) => v === null || v === undefined || Number.isNaN(Number(v));

/** N/A badge with tooltip explaining why data is missing. */
export const NA_REASON_DEFAULT = 'Data not available — not yet computed for this brand.';
